module.exports = __webpack_public_path__ + "static/media/monika-grabkowska-759473-unsplash (2).a57bc1dc.png";